import { render } from "./OnlineBanking.vue?vue&type=template&id=718c0945&ts=true"
import script from "./OnlineBanking.vue?vue&type=script&lang=ts"
export * from "./OnlineBanking.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__